module.exports = __webpack_public_path__ + "Flag-890.6168bc058ad5a96bc958a5c000b202fa.svg";